//settare isMsalLogin a true per login tramite active directory
import config from "./globalConfig";
import { LogLevel } from "@azure/msal-browser";

export const isMsalLogin = true;

export const msalConfig = {
  auth: {
    clientId: config.CLIENTID,
    authority: config.AUTHORITY,
    //authority: b2cPolicies.authorities.signUpSignIn.authority ,
    knownAuthorities: [config.AUTHORITYDOMAIN],
    redirectUri: window.location.origin + "/homepage",
    postLogoutRedirectUri: "https://serviceportal.herno.com",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid"],
};
